import React from "react";
import * as rSentry from "@sentry/react";
import { selBaseUserAssignment } from "store/slices";
import { useSelector } from "react-redux";
/* -------------------------------------------------------------------------- */
/*                                    Init                                    */
/* -------------------------------------------------------------------------- */
const env = process.env.NODE_ENV;
const initSentry = () => {
  if (env !== "production") return;
  // Initialization
  console.group("Sentry Initialization", env);
  rSentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
  });
  console.log("Initialized");
  console.groupEnd();
  const route = window.location.pathname;
  // rSentry.setTag("version", env);
  rSentry.setTag("environment", env);
  rSentry.setTag("route", route);
  /* -------------------------------------------------------------------------- */
  // Sentry.captureMessage("Info: Admin panel initiated");
};
/* -------------------------------------------------------------------------- */
/*                                   Sentry                                   */
/* -------------------------------------------------------------------------- */
const Sentry = rSentry;
/* -------------------------------------------------------------------------- */
/*                                ErrorBoundary                               */
/* -------------------------------------------------------------------------- */
const ErrorBoundary = ({ children }) => {
  const userAssignment = useSelector(selBaseUserAssignment);
  return (
    <rSentry.ErrorBoundary
      beforeCapture={(scope, error) => {
        // Capture route information
        console.log("Setnry beforeCapture");
        const route = window.location.pathname;
        scope.setTag("route", route);
        // Extract component information from stack trace
        const stackLines = error?.stack?.split("\n");
        if (stackLines && stackLines.length > 1) {
          const componentName = stackLines[1].trim().replace(/^at /, "");
          scope.setTag("component", componentName);
        }
        // Capture error message
        if (error.message) {
          scope.setExtra("error_message", error.message);
        }
        if (userAssignment?.code)
          scope.setExtra(
            "user",
            `User code: ${userAssignment.code} Airline code: ${userAssignment.airline?.unique_code}`
          ); // Include user data as extra in Sentry scope
      }}
    >
      {children}
    </rSentry.ErrorBoundary>
  );
};
/* -------------------------------------------------------------------------- */
export { initSentry, Sentry, ErrorBoundary };
